<template>
  <Head title="Register senha" />
    <GuestLayout>

    <article>
      <div class="sm:px-5 xl:max-w-[350px] xl:w-[350px]">
        <HeadingGuest title="Sobrenome" />
        <p class="pb-2">Qual é o seu sobrenome completo?</p>

        <form @submit.prevent="submit">
          <ul class="grid gap-14 pt-4">
            <li>
              <label class="mb-1 mr-5 flex font-semibold">
                Sobrenome completo
              </label>
              <Input
                placeholder="Preencha o seu sobrenome aqui.."
                type="text"
                required
                v-model="form.secondName"
              />
            </li>

            <li>
              <Button
                class="
                  w-full
                  grid
                  justify-items-center
                  items-center
                  text-primary
                  hover:bg-gray-300
                  border-primary border rounded
                  hover:border-transparent
                  font-semibold
                  p-1.5
                "
              >
                Avançar
              </Button>
            </li>
          </ul>
        </form>
      </div>
    </article>
  </GuestLayout>
</template>

<script>
import Input from "@/Components/UI/Form/Input.vue";
import GuestLayout from "@/Layouts/Guest.vue";
import Label from "@/Components/Label.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue"

export default {

  components: {
    Input,
    Label,
    ValidationErrors,
    Head,
    Link,
    GuestLayout,
    HeadingGuest
  },

  data() {
    return {
      form: this.$inertia.form({
        secondName: "",
      }),
    };
  },

  methods: {
    submit() {
      const name = sessionStorage.getItem('name')
      sessionStorage.setItem('name', `${name} ${this.form.secondName}`);
      location.href = "/register/apelido";
    },
  },
};
</script>
